export function MapIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={16} height={18} fill="none">
            <path
                fill="#A5AAAF"
                fillRule="evenodd"
                d="M8 2.334a5.833 5.833 0 0 0-4.125 9.957l3.536 3.536a.833.833 0 0 0 1.178 0l3.536-3.535A5.834 5.834 0 0 0 8 2.334ZM3.833 1.93a7.5 7.5 0 0 1 9.47 11.539l-3.535 3.536a2.5 2.5 0 0 1-3.534 0L2.697 13.47A7.5 7.5 0 0 1 3.833 1.93ZM8 6.5a1.667 1.667 0 1 0 0 3.333A1.667 1.667 0 0 0 8 6.5ZM4.667 8.167a3.333 3.333 0 1 1 6.666 0 3.333 3.333 0 0 1-6.666 0Z"
                clipRule="evenodd"
            />
        </svg>
    );
}
